import { z } from "zod";
import type { AppRole } from "@/contexts/auth-context-base";

export type { AppRole };

export const AppRoleSchema = z.enum([
  "admin",
  "diligencias_manager",
  "partner",
  "mfb",
  "mfa",
  "assessor",
  "incorporador",
  "investidor",
]);

export const ROLE_PRIORITY: AppRole[] = [
  "admin",
  "diligencias_manager",
  "partner",
  "mfb",
  "mfa",
  "assessor",
  "incorporador",
  "investidor",
] as const satisfies AppRole[];

export const AppRoleSet = new Set<AppRole>(ROLE_PRIORITY);
